import type { IconSvgObject } from './types';

const Road02Icon: IconSvgObject = [
  ["path", { d: "M4 4C2.89543 4 2 4.89543 2 6L2 18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4L4 4Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 12H11M18.5 12H16.5M7.5 12H5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Road02Icon;
